export const SHIP_TO_ID_PARAM = 'shipToId';
